export const isDesktop = typeof window.nw !== "undefined" || !!process.env.REACT_APP_EMULATE_NW;
export const isDev = process.env.REACT_APP_SM_ENV === "development";
export const supportsWebSQL = typeof window.openDatabase === "function";
export const useLocalApi = supportsWebSQL && isDesktop;
